<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerInvestmentPresenter } from '../composables/realEstateBrokerInvestmentPresenter';

const props = defineProps({
  investment: { type: Object, required: true },
});

const { t } = useI18n();
const {
  address,
  addressDetail,
  temperatureClass,
  temperatureIcon,
  temperatureLabel,
} = createRealEstateBrokerInvestmentPresenter(t);
const image = computed(() => props.investment.imagem || '');
</script>

<template>
  <LaisCard class="overflow-hidden" density="tight">
    <a
      v-if="investment.link_anuncio"
      :href="investment.link_anuncio"
      target="_blank"
      rel="noopener noreferrer"
      class="block"
    >
      <img
        v-if="image"
        :src="image"
        :alt="t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.IMAGE_ALT')"
        class="h-48 w-full object-cover sm:h-64"
      />
      <div
        v-else
        class="flex h-48 items-center justify-center bg-lais-bg-soft text-lais-text-muted sm:h-64"
      >
        <span class="i-lucide-image size-12" />
      </div>
    </a>
    <div class="space-y-4 p-5 sm:p-6">
      <div class="flex flex-wrap items-center gap-2">
        <span
          class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
          :class="temperatureClass(investment.temperatura_calculada)"
        >
          <span
            class="size-3.5"
            :class="temperatureIcon(investment.temperatura_calculada)"
          />
          {{ temperatureLabel(investment.temperatura_calculada) }}
        </span>
      </div>
      <div>
        <h2 class="text-xl font-bold text-lais-text sm:text-2xl">
          {{ address(investment) }}
        </h2>
        <p class="mt-1 text-sm text-lais-text-muted">
          {{
            addressDetail(investment) ||
            t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.NOT_INFORMED')
          }}
        </p>
      </div>
      <a
        v-if="investment.link_anuncio"
        :href="investment.link_anuncio"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-2 text-sm font-semibold text-lais-primary"
      >
        <span class="i-lucide-external-link size-4" />
        {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.OPEN_LISTING') }}
      </a>
    </div>
  </LaisCard>
</template>
